import graphql__81609bc92d6f7bf9a3e5 from "./__generated__/MapFilterTaxonomySelector_mapTaxonomy.graphql.js";import { useCallback, useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import Switch from "react-switch";
import classNames from "classnames";
import { includes, isUndefined } from "lodash";

import { useMapContext } from "../../MapContext";

// By default, we use a label tag to ensure that the Switch inner checkbox is clicked
// when the wrapper element is clicked. But to allow including the current component in
// a button (when it's the heading of a collapse), we allow customizing the wrapper
// element tag name, which avoids double click events triggering and is more WCAG/RGAA
// compatible.
const MapFilterTaxonomySelector = ({ WrapperElementTagName = "label", ...props }) => {
  const mapTaxonomy = useFragment(
    MapFilterTaxonomySelector_mapTaxonomy,
    props.mapTaxonomy
  );
  const { id, name, iconUrl } = mapTaxonomy;
  const { filterId, initiallyActive, onClick } = props;

  const { mapKey } = useMapContext();

  // A taxonomy is only ever active within the filter it's displayed in, so we read the
  // selection of that filter only. We don't default the value to an empty array here, as
  // returning a new array reference on each call would re-render this component on every
  // dispatched action.
  const activeTaxonomyIds = useSelector(
    ({ map }) => map[mapKey].filters.byFilterId[filterId]?.activeTaxonomyIds
  );

  // The `isActive` value is always forced to a boolean to avoid prop type errors when
  // passing it as a Switch prop.
  const isActive = useMemo(() => {
    if (!isUndefined(props.isActive)) return !!props.isActive;

    // The filter hasn't registered its initial selection yet, so we display the state it
    // is about to be initialized with, to avoid toggling the switch right after the map
    // has been rendered.
    if (!activeTaxonomyIds) return !!initiallyActive;

    return includes(activeTaxonomyIds, id);
  }, [activeTaxonomyIds, id, initiallyActive, props.isActive]);

  const handleSwitchChanged = useCallback(() => {
    if (onClick) onClick(mapTaxonomy);
  }, [mapTaxonomy, onClick]);

  const className = classNames("btn", "btn-block-md", "padding-y-xs", props.className);

  return (
    <WrapperElementTagName className={className}>
      {iconUrl && <img src={iconUrl} className="map-filter-icon margin-right-xs" />}
      {name}

      <Switch
        onChange={handleSwitchChanged}
        checked={isActive}
        className="float-right"
        width={34}
        height={17}
        checkedIcon={false}
        uncheckedIcon={false}
      />
    </WrapperElementTagName>
  );
};

const MapFilterTaxonomySelector_mapTaxonomy = graphql__81609bc92d6f7bf9a3e5;

export default MapFilterTaxonomySelector;
